import React from 'react'
import { data } from './data/index'
import imagesPairs from './data/imagesPairs'
import Image from 'next/legacy/image'
import { rgbDataURL } from '../puppyProfile/lib/utils'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay } from 'swiper/modules'

// Styles
import styles from './carousel.module.scss'

const GroupImages = ({ img1, img2, alt1, alt2 }) => (
  <div className={styles.container}>
    <Image
      height={176}
      width={176}
      src={img1}
      alt={alt1}
      className={styles.images}
      placeholder='blur'
      blurDataURL={rgbDataURL(238, 238, 238)}
      layout='intrinsic'
      loading='lazy'
    />
    <Image
      height={176}
      width={176}
      src={img2}
      alt={alt2}
      className={styles.images}
      placeholder='blur'
      blurDataURL={rgbDataURL(238, 238, 238)}
      layout='intrinsic'
      loading='lazy'
    />
  </div>
)

export default function CarouselPuppies () {
  const length = data.length

  return (
    <div className={styles.main}>
      <Swiper
        modules={[Autoplay]}
        initialSlide={0}
        grabCursor
        autoplay={{
          delay: 2500,
          disableOnInteraction: true
        }}
        spaceBetween={5}
        slidesPerView={6}
        pagination={{
          clickable: true
        }}
        breakpoints={{
          1020: {
            slidesPerView: 6,
            spaceBetween: 5
          },
          860: {
            slidesPerView: 5,
            spaceBetween: 5
          },
          540: {
            slidesPerView: 4,
            spaceBetween: 5
          },
          360: {
            slidesPerView: 'auto',
            spaceBetween: 5
          },
          300: {
            slidesPerView: 'auto',
            spaceBetween: 5
          },
          290: {
            slidesPerView: 'auto',
            spaceBetween: 5
          }
        }}
      >
        {(imagesPairs(data) || [])?.map((c, i) => (
          <SwiperSlide key={i}>

            <GroupImages img1={c[0].img} alt1={c[0].alt} img2={c[1].img} alt2={c[1].alt} />

          </SwiperSlide>
        ))

          .slice(0, length)}
      </Swiper>
    </div>
  )
}
